export var formFields = {
    signIn: {
        username: {
            labelHidden: true,
            placeholder: 'Email',
        },
        password: {
            labelHidden: true,
            placeholder: 'Password',
        },
    },
    signUp: {
        given_name: {
            labelHidden: true,
            placeholder: 'First Name',
            order: 1,
        },
        family_name: {
            labelHidden: true,
            placeholder: 'Last Name',
            order: 2,
        },
        email: {
            labelHidden: true,
            placeholder: 'Email',
            order: 3,
        },
        password: {
            labelHidden: true,
            placeholder: 'Password',
            order: 4,
        },
        confirm_password: {
            labelHidden: true,
            placeholder: 'Confirm Password',
            order: 5,
        },
    },
    confirmSignUp: {
        confirmation_code: {
            labelHidden: true,
        },
    },
    resetPassword: {
        username: {
            labelHidden: true,
        },
    },
    confirmResetPassword: {
        confirmation_code: {
            labelHidden: true,
            order: 1,
        },
        password: {
            labelHidden: true,
            order: 2,
        },
        confirm_password: {
            labelHidden: true,
            order: 3,
        },
    },
    forceNewPassword: {
        password: {
            labelHidden: true,
            order: 2,
        },
        confirm_password: {
            labelHidden: true,
            order: 3,
        },
    },
};
